import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REQUESTED_TMS = restRequest(
    "REQUESTED_TM_PLANS.GET_REQUESTED_TMS"
);
export const GET_REQUESTED_ENDPOINTS = restRequest(
    "REQUESTED_TM_PLANS.GET_REQUESTED_ENDPOINTS"
);
export const SET_ROWS_PER_PAGE = "REQUESTED_TM_PLANS.SET_ROWS_PER_PAGE";
export const SET_PAGE = "REQUESTED_TM_PLANS.SET_PAGE";
export const SET_REPORT_STATUS = restRequest(
    "REQUESTED_TM_PLANS.SET_REPORT_STATUS"
);
export const SET_SELECTED_ROW = "REQUESTED_TM_PLANS.SET_SELECTED_ROW";
export const SET_REPORT_EDIT_STATUS = restRequest(
    "REQUESTED_TM_PLANS.SET_REPORT_EDIT_STATUS"
);
export const SET_STATUS_CHANGE_MODAL_INFO =
    "REQUESTED_TM_PLANS.SET_STATUS_CHANGE_MODAL_INFO";
export const DELETE_REPORT = restRequest("REQUESTED_TM_PLANS.DELETE_REPORT");
export const SET_DELETE_STATUS = "REQUESTED_TM_PLANS.SET_DELETE_STATUS";
export const GET_TMPLAN_TMS = restRequest(
    "REQUESTED_TM_PLANS.GET_TMPLAN_TMS"
);
